const useTaskResourceEstimateChangeHandlers = ({
  onResourceEstimateChange,
  resourceEstimate
}) => ({
  onRemove: () => {
    onResourceEstimateChange({
      assignment: resourceEstimate,
      isDelete: true
    });
  },
  onEstimatedHoursChange: hours =>
    onResourceEstimateChange({
      assignment: {
        ...resourceEstimate,
        estimatedHours: hours,
        estimatedCost: {
          amount: hours * 100,
          currencySymbol: '$'
        }
      }
    }),
  onResourceChange: resource =>
    onResourceEstimateChange({
      assignment: {
        ...resourceEstimate,
        resource
      }
    }),
  onRoleChange: role =>
    onResourceEstimateChange({
      assignment: {
        ...resourceEstimate,
        role
      }
    }),
  onAllocationDateChange: dateRange =>
    onResourceEstimateChange({
      assignment: {
        ...resourceEstimate,
        dateRange
      }
    })
});

export default useTaskResourceEstimateChangeHandlers;
